import { db, oid } from '../firebase';

export const updateCompletedMissions = (missionId) =>
  db.ref(`appData/${oid}/missions`)
    .update({ [missionId]: "completed"})

export const getMissions = () =>
  db.ref(`appData/${oid}/missions`);



// WEBPACK FOOTER //
// ./src/firebase/database/help.js